// Browser support:
// Chrome 66+ | Safari 13.1+ | Firefox 63+ | Opera 53+ | Edge 79+

export default (text: string) => navigator?.clipboard?.writeText(text);
